import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { autoSelectFirstLyrics } from './autoSelectLyrics';
import { useOrder } from './useOrder';
import { Page } from './ui';

export default function RecordingPage() {
  const { slug = '' } = useParams();
  const navigate = useNavigate();
  const { order, error, loading } = useOrder(slug, { pollMs: 4000 });
  const [selectError, setSelectError] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (!order) return;
    if (order.status === 'previa_pronta') {
      navigate(`/criar-musica/previa/${order.slug}`, { replace: true });
    }
  }, [order, navigate]);

  useEffect(() => {
    if (!order || started.current) return;
    if (order.status === 'letras_prontas' && order.lyricsOptions?.length) {
      started.current = true;
      autoSelectFirstLyrics(order).catch((err) => {
        started.current = false;
        setSelectError(err instanceof Error ? err.message : 'select_lyrics_failed');
      });
    }
  }, [order]);

  useEffect(() => {
    if (!('Notification' in window) || Notification.permission !== 'default') return;
    Notification.requestPermission().catch(() => undefined);
  }, []);

  if (loading) return <Page><section className="cm-panel"><p className="cm-kicker">Carregando…</p></section></Page>;
  if (error || !order) return <Page><section className="cm-panel"><p className="cm-error">{error || 'Pedido não encontrado.'}</p></section></Page>;

  return (
    <Page>
    <section className="cm-panel cm-studio">
      <p className="cm-kicker">Estúdio</p>
      <h1 className="cm-title">Tá nascendo a música de {order.recipientName}</h1>
      <p className="cm-lead">A gente está cantando 1 minuto agora. Fica nesta tela — quando a prévia ficar pronta, ela abre sozinha.</p>
      <div className="cm-studio-art" aria-hidden="true">
        <span /><span /><span /><span /><span />
      </div>
      {selectError && <p className="cm-error">Não deu pra começar a gravação. Atualize a página.</p>}
      <p className="cm-note">Isso costuma levar alguns minutos. Você também pode voltar depois pelo mesmo link.</p>
      <Link className="cm-ghost" to={`/criar-musica/pedido/${order.slug}`}>Ver o pedido</Link>
    </section>
    </Page>
  );
}
